var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterRemLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.001,
    height: 28.466
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32507",
    fill: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M35.377 4.54c0-2.956-.68-3.04-4.3-3.756V.066H43.11c5.188 0 9.482 1.224 9.482 7.3 0 4.809-3.614 6.37-7.355 6.878l8.588 14.221h-4.158l-8.462-13.968h-2.128v13.968h-3.7zm3.7 8.312h1.148c3.019 0 8.207 0 8.207-5.908 0-4.009-3.018-5.233-6.336-5.233-2.849 0-3.019.339-3.019 2.829z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M57.616 4.496c0-2.406-.594-3.207-4.293-3.714V.064h20.068l.214 5.149h-1.319c-.426-2.2-.383-3.5-3.912-3.5h-4.465c-2.424 0-2.594.507-2.594 2.786v8.312h5.4c3.528 0 3.826-1.519 4.167-3.5h.976v8.736h-.976c-.427-2.448-.555-3.588-4.167-3.588h-5.4v9.917c0 2.447.383 2.447 3.485 2.447h4.594c2.891 0 3.1-.886 3.7-4.092h1.317l-.3 5.739h-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M80.873 5.044c0-3.376-.511-3.5-4.251-4.262V.064h9.31l8.421 24.263h.084L102.854.064H108v28.4h-3.7V2.301h-.085l-8.889 26.163h-3.315L83.165 2.301h-.084v26.163h-2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M28.587 4.37a4.4 4.4 0 00-4.4-4.37H0v24a4.4 4.4 0 004.4 4.37h24.183zM7.898 26.857a3.487 3.487 0 01-3.49-3.463V4.374h19.167a3.489 3.489 0 013.491 3.463v19.02H7.898z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M21.028 14.009h-6.906v6.855a1.26 1.26 0 001.259 1.249h6.909v-6.857a1.256 1.256 0 00-1.257-1.248"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M23.056 7.495H7.631v15.311a2.807 2.807 0 002.809 2.786h15.425v-15.31a2.808 2.808 0 00-2.809-2.787M12.931 23.402a1.961 1.961 0 01-1.959-1.945V10.784h10.755a1.958 1.958 0 011.958 1.945v10.674H12.931z"
  }))));
}

export default __webpack_public_path__ + "footer-rem-logo-e61cd7a31f8bbc8c2472e2ea3b081dce.svg";
export { SvgFooterRemLogo as ReactComponent };